import {IHttpPromise, IHttpResponse, IHttpService} from "angular";
import {Address} from "../../address/model/Address";
import {getAbsoluteUrl} from "../../utils/urlUtill";

export class BranchesAddressService {

    public static instance = ['$http', BranchesAddressService];


    constructor(private $http: IHttpService) {
    }

    public updateAddress = (branchId: number, address: Address): IHttpPromise<IHttpResponse<Address>> =>
        this.$http({
            url: getAbsoluteUrl(`api/branches/${branchId}/address`),
            method: 'POST',
            data: address,
        })

}